
import { Category } from '../types';
import { storage } from '../lib/storage';

export const categoryService = {
  async getStoreCategories(storeId: string): Promise<Category[]> {
    const all = storage.getCategories();
    return all.filter(c => c.storeId === storeId);
  },

  async addCategory(category: Omit<Category, 'id'>): Promise<Category> {
    const all = storage.getCategories();
    const newCategory = { ...category, id: 'cat-' + Date.now() };
    storage.saveCategories([newCategory, ...all]);
    return newCategory;
  },

  async deleteCategory(id: string): Promise<void> {
    const all = storage.getCategories();
    storage.saveCategories(all.filter(c => c.id !== id));
  }
};
